/**
 * Query to fetch org_modules filtered by module ID.
 * Used for the two-step module filter: first resolve org IDs that have a given module,
 * then filter organizzaziones by those IDs.
 */
const orgModulesByModuleQuery = `
query OrgModulesByModule($where: Org_moduleWhereInput) {
  org_modules(where: $where, first: 10000) {
    edges {
      node {
        org_pointer {
          objectId
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default orgModulesByModuleQuery;
